<template>
  <div class="input-container">
    <div>
      <div :class="['input-container']">
        <input
          :class="['input-class']"
          ref="optionsInput"
          type="text"
          v-model="localModel"
          :placeholder="placeholder"
          :disabled="desabilita"
          @keydown.prevent.up="highlightIncrement(-1)"
          @keydown.prevent.down="highlightIncrement(1)"
          @keydown.enter="selectOption"
          @keydown.shift.tab=""
          @keydown.tab.prevent="selectTab"
          @keydown.esc="setBlurOptions"
          @focus="focus"
          @blur="blur"
        />
        <div
          v-show="!readonly && !desabilita"
          @click="clickIcon"
          @contextmenu.prevent="clickIcon"
          @mouseover="holdBlur = true"
          @mouseleave="holdBlur = false"
          :class="['input-icon', { 'input-icon-opened': showDropdown }]"
        >
          <font-awesome-icon icon="chevron-up" />
        </div>
        <div
          v-if="!desabilita"
          v-show="showClear && !readonly"
          @click="clearInput"
          @contextmenu.prevent="clearInput"
          :class="['input-icon', 'input-icon-secondary']"
        >
          <font-awesome-icon icon="times" />
        </div>
      </div>
      <div class="dropdown-container">
        <!-- <transition name="dropDown"> -->
        <div
          @mouseover="holdBlur = true"
          @mouseleave="holdBlur = false"
          ref="dropdown"
          v-show="showDropdown"
          tabindex="0"
          class="options-dropdown"
        >
          <div
            v-b-tooltip.hover.left.window
            :title="option.nome && option.nome.length > 30 ? option.nome : ''"
            v-for="(option, index) in filteredOptions"
            ref="dropdownOptions"
            :key="index"
            v-if="index < loadElement"
            :class="[
              'option-component',
              { 'dropdown-highlighted': index === highlightedIndex },
              { 'dropdown-no-selection': noSelection }
            ]"
            @mouseover="highlightOption(index)"
            @click="selectOption"
            @contextmenu.prevent="selectOption"
          >
            <div>
              {{ option.nome }}
            </div>
          </div>
        </div>
        <!-- </transition> -->
      </div>
    </div>
  </div>
</template>

<script>
import TheMask from "vue-the-mask";
import vMoney from "v-money";

export default {
  name: "HeaderInput",
  props: {
    nome: String,
    maxlength: String,
    validaCampos: Object,
    exibeValidacao: Boolean,
    tipo: String,
    placeholder: String,
    desabilita: Boolean,
    noOptions: String,
    model: String | Number,
    options: Array | Object,
    object: Array,
    mask: String,
    cnpj: Object,
    readonly: Boolean,
    loading: Boolean,
    dinheiro: Boolean
  },
  component: {
    TheMask,
    vMoney
  },
  data() {
    return {
      holdCreated: false,
      noSelection: false,
      showDropdown: false,
      highlightedIndex: 0,
      holdBlur: false,
      selected: "",
      localModelBackup: "",
      loadElement: 50,
      bypassBlur: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },
  created() {
    // setTimeout(() => {
    //   this.holdCreated = false;
    // }, 3000);
    setTimeout(() => {
      this.correrTexto();
    }, 3000);
  },
  mounted() {
    if (this.$refs.dropdown) {
      this.$refs.dropdown.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    this.$refs.dropdown.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    localModel: {
      get() {
        if (this.model) {
          return this.model;
        }
        return "";
      },
      set(newValue) {
        this.$emit("update:model", newValue);
      }
    },
    filteredOptions() {
      // if (this.options.length == 0) {
      //   return [{ name: "Cadastre uma empresa" }];
      // }
      if (this.localModel && this.localModel != "") {
        this.highlightedIndex = 0;
        let options =
          this.options && this.options.length
            ? this.options.filter(p =>
                p.nome
                  ? p.nome
                      .replaceAll(" ", "")
                      .replaceAll(".", "")
                      .toLowerCase()
                      .includes(
                        this.localModel
                          .replaceAll(" ", "")
                          .replaceAll(".", "")
                          .toLowerCase()
                      )
                  : ""
              )
            : [];
        // return options
        this.noSelection = !!options.length ? false : true;
        return !!options.length
          ? options
          : [this.noOptions ? { nome: this.noOptions } : { nome: "Sem opções disponíveis" }];
      }
      return this.options && this.options.length
        ? this.options
        : [{ nome: "Cadastre uma empresa" }];
    },
    showClear() {
      if (this.localModel != "") {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleScroll(event) {
      if (
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 100 &&
        this.filteredOptions.length > this.loadElement
      ) {
        this.loadElement += 50;
      }
    },
    highlightOption(index) {
      this.highlightedIndex = index;
    },
    highlightIncrement(increment) {
      this.highlightedIndex += increment;

      if (this.filteredOptions.length <= this.loadElement) {
        this.highlightedIndex < 0
          ? (this.highlightedIndex = this.filteredOptions.length - 1)
          : this.highlightedIndex;
        this.highlightedIndex > this.filteredOptions.length - 1
          ? (this.highlightedIndex = 0)
          : this.highlightedIndex;
      } else {
        this.highlightedIndex < 0 ? (this.highlightedIndex = 0) : this.highlightedIndex;
        this.highlightedIndex > this.filteredOptions.length - 1
          ? (this.highlightedIndex = 0)
          : this.highlightedIndex;
      }

      if (
        this.filteredOptions[this.highlightedIndex] &&
        this.filteredOptions[this.highlightedIndex].header
      ) {
        this.highlightedIndex > 0
          ? (this.highlightedIndex += increment)
          : (this.highlightedIndex += 1);
      }

      this.$refs.dropdownOptions[this.highlightedIndex].scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "center"
      });
    },
    selectOption() {
      if (this.holdCreated) return;

      this.$nextTick(() => {
        this.holdBlur = false;
        let options = this.noOptions
          ? { nome: this.noOptions }
          : { nome: "Sem opções disponíveis" };
        let vazio = { nome: "Cadastre uma empresa" };
        if (JSON.stringify(this.filteredOptions[0]) == JSON.stringify(options)) {
          this.localModel = this.localModelBackup;
          this.showDropdown = false;
          return;
        }
        if (JSON.stringify(this.filteredOptions[0]) == JSON.stringify(vazio) && this.showDropdown) {
          this.$router.push("/empresas");
          this.showDropdown = false;
          return;
        }
        if (this.$refs.optionsInput) {
          this.$refs.optionsInput.blur();
        }
        this.showDropdown = false;
        this.localModel = this.filteredOptions[this.highlightedIndex].nome;
        this.localModelBackup = this.filteredOptions[this.highlightedIndex].nome;

        this.$nextTick(() => {
          this.$emit(
            "selected",
            this.options.find(f => f.nome == this.localModel)
          );
        });
      });
    },
    focus() {
      if (this.readonly) {
        return;
      }
      this.localModelBackup = this.localModel;
      this.showDropdown = true;
      this.highlightedIndex = 0;
      this.placeholderModified = this.model;
      this.localModel = "";
      this.loadElement = 50;
      // if (this.loading) return;
      if (this.$refs.dropdownOptions && this.$refs.dropdownOptions[this.highlightedIndex]) {
        this.$nextTick(() => {
          this.$refs.dropdownOptions[this.highlightedIndex].scrollIntoView({
            behavior: "auto",
            block: "nearest",
            inline: "center"
          });
        });
      }
    },
    setBlurOptions() {
      this.$refs.optionsInput.blur();
    },
    blur() {
      if (this.readonly) {
        return;
      }
      if (!this.holdBlur || this.bypassBlur) {
        this.$nextTick(() => {
          this.showDropdown = false;
          if (this.localModelBackup != this.placeholder) {
            this.localModel = this.localModelBackup;
          } else {
            this.localModel = "";
          }
          // }
          this.placeholderModified = this.placeholder;
          this.bypassBlur = false;
        });
      }
    },
    clickIcon() {
      if (!this.showDropdown) {
        this.$refs.optionsInput.focus();
      } else {
        this.showDropdown = false;
        this.localModel = this.localModelBackup;
      }
    },
    clearInput() {
      this.placeholderModified = this.placeholder;
      this.selected = "";
      this.$emit("selected", "");
      this.$nextTick(() => {
        this.localModelBackup = this.model;
        this.localModel = "";
      });
    },
    selectTab() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.selectOption();
        });
      });
    },
    correrTexto() {
      const animacao = () => {
        const input = this.$refs.optionsInput;
        const tamanhoTexto = input ? input.scrollWidth : null;
        if (input && input.scrollLeft == 0 && this.localModel != "") {
          setTimeout(() => {
            input.scrollLeft = 2;
            animacao();
          }, 3000);
        } else if (input && tamanhoTexto > input.offsetWidth) {
          requestAnimationFrame(() => {
            input.scrollLeft += 2;
            if (input.scrollLeft < tamanhoTexto - 259) {
              setTimeout(() => {
                animacao();
              }, 30);
            } else {
              setTimeout(() => {
                input.scrollLeft = 0;
                animacao();
              }, 3000);
            }
          });
        } else {
          setTimeout(() => {
            input ? (input.scrollLeft = 0) : null;
            animacao();
          }, 500);
        }
      };
      animacao();
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  width: 260px;
  height: 40px;
  background: var(--azul5);
  position: relative;
}
.input-class {
  padding: 0.4rem 3.5rem 0.4rem 0.8rem;
  width: 100%;
  height: 100%;
  border: 1px solid var(--azul5);
  // scroll-behavior: smooth !important;
  // padding-left: -100px !important;
}
.dropdown-container {
  position: relative;
}
.option-component {
  padding: 3px 20px;
  height: 25px;
  white-space: nowrap;
  cursor: pointer;
  // height: 25px;
  overflow: hidden;
  &:nth-child(even) {
    background: #cccccc2c;
  }
}
.options-dropdown {
  position: absolute;
  top: 0;
  background: var(--azul4);
  z-index: 1000;
  width: 100%;
  border: 1px solid var(--azul5);
  border-top: 2px solid var(--azul5);
  padding: 0px 0;
  max-height: 365px;
  overflow-y: auto;
  scroll-behavior: auto;
  .dropdown-highlighted {
    background: var(--azul2);
    color: var(--branco);
  }
  .dropdown-no-selection {
    background: var(--azul4);
    color: var(--branco);
  }
}
.dropDown-enter-active,
.dropDown-leave-active {
  transition: all 0.15s ease-in-out;
  z-index: 1000;
}
.dropDown-enter,
.dropDown-leave-to {
  max-height: 0;
}
.input-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 25px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: rotate 0.2s ease;
  rotate: -180deg;
  color: var(--branco);
  font-size: 15px;
}
.input-icon-opened {
  rotate: 0deg;
}
.input-icon-secondary {
  right: 25px;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 1px;
}
</style>
